export enum SystemNotificationKey {
  PaymentSignup = 'payment-signup',
  UpdateIntegration = 'update-integration',
}
